<template>
  <a target="_blank" data-ajax-off="true" :href="url">
    <aw-icon icon="download" class="w-5 h-5 "></aw-icon>
    {{ $t(title) }}
  </a>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Export'
    }
  },
  computed: {
    url() {
      return this.$presenter.exportUrl
    }
  }
}
</script>

<style lang="scss" scoped></style>
